<template
  class="tw-flex tw-min-h-[670px] tw-flex-[1_0_0] tw-flex-col tw-items-center tw-gap-6 tw-self-stretch tw-overflow-visible tw-p-4"
>
  <div class="tw-h-screen tw-w-screen">
    <!-- Housemate Group Join Modal -->
    <HousemateGroupModal
      :show="true"
      :show-close-icon="false"
      dynamic-body-class="md:tw-py-[16px] md:tw-px-[24px] tw-px-[24px] tw-py-[16px]"
      @close-modal="handleDeclineAction"
    >
      <template #header> Grouplist Invitation </template>

      <template #body>
        <div
          class="tw-flex tw-flex-col tw-items-start tw-gap-[24px] tw-self-stretch"
        >
          <div
            class="tw-font-inter tw-text-left tw-text-[16px] tw-font-normal tw-leading-[1.5] tw-text-[#3B4143]"
          >
            <span v-if="studentStore.hasGroupJoinError">{{
              joinHeaderText
            }}</span>
            <span v-else>You've received an invitation to</span>
          </div>

          <div
            class="tw-font-inter tw-self-stretch tw-text-left tw-text-[16px] tw-font-bold tw-leading-[1.5] tw-text-[#3B4143]"
          >
            {{ joinHousemateGroupName }}
          </div>
          <div
            v-show="!studentStore.hasGroupJoinError"
            class="tw-font-inter tw-self-stretch tw-text-left tw-text-[16px] tw-font-normal tw-leading-[1.5]"
          >
            If you decline, you will need to click the shared link again to
            enter this group
          </div>

          <div
            v-show="studentStore.hasGroupJoinError"
            :class="joinStatusClass"
            class="tw-self-stretch tw-text-left tw-text-[16px] tw-font-bold tw-leading-[1.5]"
          >
            {{ studentStore.groupJoinErrorMsg }}
          </div>
        </div>
      </template>

      <!-- Actions -->
      <template #actions>
        <div v-if="isAlreadyMember" class="tw-w-full">
          <button
            type="button"
            class="tw-flex tw-h-[50px] tw-w-full tw-min-w-[156px] tw-items-center tw-justify-center tw-gap-[8.333px] tw-rounded-[25px] tw-border tw-border-[#0EA5E9] tw-bg-[#EFF6FF] tw-px-[13.333px] tw-py-[6.667px] tw-transition tw-duration-150 tw-ease-in-out active:tw-bg-[#DBEAFE]"
            @click="redirectToGrouplistSearch()"
          >
            <span
              class="tw-font-inter tw-text-[14px] tw-font-normal tw-leading-normal tw-text-[#00A2E1]"
            >
              Return to search
            </span>
          </button>
        </div>

        <div v-else class="tw-flex tw-w-full tw-flex-row tw-gap-[16px]">
          <div class="tw-flex-1">
            <button
              type="button"
              :disabled="disableAcceptButton"
              class="tw-flex tw-h-[50px] tw-w-full tw-min-w-[156px] tw-items-center tw-justify-center tw-gap-[8.333px] tw-rounded-[25px] tw-border tw-border-[#497D00] tw-bg-[#FAFFF0] tw-px-[13.333px] tw-py-[6.667px] tw-transition tw-duration-150 tw-ease-in-out active:tw-bg-[#E6F0C8] disabled:tw-opacity-60"
              @click="handleAcceptAction(joinHousemateGroupId)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  d="M19.3051 6.60972C19.1192 6.39912 18.8907 6.23047 18.6347 6.11497C18.3786 5.99947 18.1009 5.93977 17.8201 5.93982H13.2001V4.61982C13.2001 3.74461 12.8524 2.90524 12.2335 2.28637C11.6147 1.6675 10.7753 1.31982 9.90007 1.31982C9.77745 1.31974 9.65724 1.35381 9.5529 1.41822C9.44857 1.48262 9.36424 1.57482 9.30937 1.68447L6.19252 7.91982H2.64007C2.28998 7.91982 1.95424 8.0589 1.70669 8.30644C1.45914 8.55399 1.32007 8.88974 1.32007 9.23982V16.4998C1.32007 16.8499 1.45914 17.1857 1.70669 17.4332C1.95424 17.6808 2.28998 17.8198 2.64007 17.8198H16.8301C17.3125 17.82 17.7783 17.6441 18.1401 17.3251C18.502 17.006 18.7349 16.5659 18.7952 16.0873L19.7852 8.16732C19.8203 7.88849 19.7956 7.60539 19.7129 7.33683C19.6301 7.06827 19.4911 6.82041 19.3051 6.60972ZM2.64007 9.23982H5.94007V16.4998H2.64007V9.23982ZM18.4751 8.00232L17.4851 15.9223C17.465 16.0819 17.3874 16.2286 17.2668 16.3349C17.1461 16.4412 16.9909 16.4999 16.8301 16.4998H7.26007V8.73575L10.2886 2.67777C10.7375 2.76761 11.1414 3.01021 11.4315 3.36429C11.7217 3.71837 11.8802 4.16205 11.8801 4.61982V6.59982C11.8801 6.77487 11.9496 6.94274 12.0734 7.06651C12.1972 7.19029 12.365 7.25982 12.5401 7.25982H17.8201C17.9137 7.25979 18.0063 7.27969 18.0917 7.31821C18.1771 7.35672 18.2533 7.41296 18.3152 7.48319C18.3772 7.55342 18.4235 7.63604 18.4511 7.72554C18.4786 7.81505 18.4868 7.9094 18.4751 8.00232Z"
                  fill="#497D00"
                />
              </svg>

              <span
                class="tw-font-inter tw-text-[14px] tw-font-normal tw-leading-normal tw-text-[#497D00]"
              >
                Accept
              </span>
            </button>
          </div>

          <div class="tw-flex-1">
            <button
              type="button"
              :disabled="disableDeclineButton"
              class="tw-flex tw-h-[50px] tw-w-full tw-min-w-[156px] tw-items-center tw-justify-center tw-gap-[8.333px] tw-rounded-[25px] tw-border tw-border-[#E7000B] tw-bg-[#FFF2F2] tw-px-[13.333px] tw-py-[6.667px] tw-transition tw-duration-150 tw-ease-in-out active:tw-bg-[#FFD6D6] disabled:tw-opacity-60"
              @click="handleDeclineAction"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="17"
                viewBox="0 0 19 17"
                fill="none"
              >
                <path
                  d="M18.4652 9.6525L17.4752 1.7325C17.4149 1.2539 17.1819 0.813779 16.8201 0.494775C16.4582 0.175772 15.9924 -0.000165461 15.51 1.16764e-07H1.32C0.969914 1.16764e-07 0.634167 0.139071 0.386619 0.386619C0.139071 0.634167 0 0.969914 0 1.32V8.58C0 8.93009 0.139071 9.26583 0.386619 9.51338C0.634167 9.76093 0.969914 9.9 1.32 9.9H4.87245L7.9893 16.1354C8.04417 16.245 8.1285 16.3372 8.23284 16.4016C8.33717 16.466 8.45739 16.5001 8.58 16.5C9.45521 16.5 10.2946 16.1523 10.9135 15.5335C11.5323 14.9146 11.88 14.0752 11.88 13.2V11.88H16.5C16.781 11.8801 17.0587 11.8204 17.3149 11.7049C17.571 11.5893 17.7996 11.4206 17.9855 11.2099C18.1713 10.9992 18.3102 10.7514 18.393 10.4828C18.4757 10.2143 18.5003 9.93127 18.4652 9.6525ZM4.62 8.58H1.32V1.32H4.62V8.58ZM16.995 10.3364C16.9335 10.4072 16.8574 10.4638 16.772 10.5024C16.6865 10.541 16.5938 10.5606 16.5 10.56H11.22C11.045 10.56 10.8771 10.6295 10.7533 10.7533C10.6295 10.8771 10.56 11.045 10.56 11.22V13.2C10.5601 13.6578 10.4016 14.1015 10.1115 14.4555C9.82133 14.8096 9.41745 15.0522 8.96858 15.1421L5.94 9.08408V1.32H15.51C15.6708 1.31995 15.8261 1.37859 15.9467 1.48493C16.0673 1.59126 16.145 1.73797 16.1651 1.8975L17.1551 9.8175C17.1674 9.91042 17.1595 10.0049 17.1319 10.0945C17.1043 10.1841 17.0576 10.2666 16.995 10.3364Z"
                  fill="#E7000B"
                />
              </svg>

              <span
                class="tw-font-inter tw-text-[14px] tw-font-normal tw-leading-normal tw-text-[#E7000B]"
              >
                Decline
              </span>
            </button>
          </div>
        </div>
      </template>
    </HousemateGroupModal>
  </div>
</template>

<script>
import { useStudentStore } from '@js/stores/student/student';
import HousemateGroupModal from '@components/Student/Modal/HousemateGroupModal.vue';

export default {
  components: { HousemateGroupModal },
  props: {
    joinHousemateGroup: {
      default: false,
      type: Boolean,
    },
    joinHousemateGroupId: {
      default: null,
      type: Number,
    },
    joinHousemateGroupName: {
      default: null,
      type: String,
    },
    lastSearchUrl: {
      default: null,
      type: String,
    },
    housemateGroupInviteSearchUrl: {
      default: null,
      type: String,
    },
    error: {
      default: false,
      type: Boolean,
    },
    errorMsg: {
      default: null,
      type: String,
    },
    joinStatus: {
      default: null,
      type: String,
    },
    defaultHousemateGroupCity: {
      default: null,
      type: String,
    },
  },
  data() {
    const studentStore = useStudentStore();

    return {
      studentStore,
      disableAcceptButton: false,
      disableDeclineButton: false,
    };
  },
  computed: {
    isAlreadyMember() {
      return this.error && this.joinStatus === 'APPROVED';
    },
    joinHeaderText() {
      if (this.joinStatus === 'APPROVED') {
        return "You're already in this grouplist";
      }

      return "You've already requested to join";
    },
    joinStatusClass() {
      switch (this.joinStatus) {
        case 'PENDING':
          return 'tw-text-orange-600';
        case 'APPROVED':
          return 'tw-text-green-600';
        default:
          return 'tw-text-red-600';
      }
    },
  },
  mounted() {
    if (this.error) {
      this.studentStore.setHousemateGroupJoinError(this.errorMsg);
      this.disableAcceptButton = true;
    }
  },
  methods: {
    buildGrouplistSearchPath() {
      if (this.housemateGroupInviteSearchUrl) {
        return this.housemateGroupInviteSearchUrl;
      }

      const city = (this.defaultHousemateGroupCity || 'sheffield').trim();

      return `/student-accommodation/${encodeURIComponent(city)}?tab=grouplist`;
    },
    redirectToGrouplistSearch() {
      window.location.href = this.buildGrouplistSearchPath();
    },
    redirectUser(path = null) {
      if (path) {
        window.location.href = path;
        return;
      }

      if (!path && this.housemateGroupInviteSearchUrl) {
        window.location.href = this.housemateGroupInviteSearchUrl;
        return;
      }

      if (!path && this.lastSearchUrl) {
        window.location.href = this.lastSearchUrl;
        return;
      }

      window.location.href = this.buildGrouplistSearchPath();
    },
    handleDeclineAction() {
      this.disableAcceptButton = true;
      this.redirectUser();
    },
    async handleAcceptAction() {
      this.disableAcceptButton = true;
      this.disableDeclineButton = true;
      await this.studentStore.postJoinHousemateGroup(this.joinHousemateGroupId);

      if (!this.studentStore.hasGroupJoinError) {
        this.redirectToGrouplistSearch();
      }
    },
  },
};
</script>
